import { render } from "./CoverageHistory.vue?vue&type=template&id=2e7b6710&ts=true"
import script from "./CoverageHistory.vue?vue&type=script&lang=ts"
export * from "./CoverageHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__